import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=83ab10c8"
import script from "./LinkList.vue?vue&type=script&lang=js"
export * from "./LinkList.vue?vue&type=script&lang=js"
import style0 from "./LinkList.vue?vue&type=style&index=0&id=83ab10c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LinkList.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports